"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _collection = require("lodash/collection");

var _googleDisplayAd = _interopRequireDefault(require("./google/googleDisplayAd"));

var _config = require("./config");

var _queue = _interopRequireDefault(require("./utils/queue"));

var _getGlobal = _interopRequireDefault(require("./utils/getGlobal"));

var global = (0, _getGlobal.default)();

var mockDisplayAd = function mockDisplayAd(adId, config) {
  var mockNetworkDelayMs = 0;
  var useMockDelay = false;

  if (useMockDelay) {
    mockNetworkDelayMs = Math.random() * (1500 - 900) + 900;
  }

  var adUnit = (0, _collection.find)(config.adUnits, {
    adId: adId
  }); // Use the height of the first specified size of this ad unit.

  var height = adUnit && adUnit.sizes ? adUnit.sizes[0][1] : 0; // Mock returning an ad.

  setTimeout(function () {
    var elem = global.document.getElementById(adId);

    if (!elem) {
      return;
    }

    elem.setAttribute('style', "\n      color: white;\n      background: repeating-linear-gradient(\n        -55deg,\n        #222,\n        #222 20px,\n        #333 20px,\n        #333 40px\n      );\n      width: 100%;\n      height: ".concat(height, "px;\n    "));
  }, mockNetworkDelayMs);
};

var _default = function _default(adId) {
  // `fetchAds` may not have been called yet, so queue
  // any commands that rely on the config.
  (0, _queue.default)(function () {
    var config = (0, _config.getConfig)();

    if (!config.disableAds) {
      (0, _googleDisplayAd.default)(adId);
    } else if (config.useMockAds) {
      mockDisplayAd(adId, config);
    }
  });
};

exports.default = _default;